import React from "react"
import { Typography, Card, CardContent, Divider } from "@mui/material"
// import { useAuth } from "../../context/AuthContext" // Auth related Data
// import { useAppData } from "../../context/AppDataContext" // In App related Data
// import { toast } from "react-toastify"
// import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import dayjs from "dayjs"
// import { useVariableData } from "../../context/VariableDataContext"
// import axios from "axios"
// import { BarChart } from "@mui/x-charts/BarChart"
// import { color, motion } from "framer-motion"

import VAPieChart2 from "../../../components/VAPieChart2"
// import VAPieChart from "../../components/VAPieChart"

const currentDayjs = dayjs()

const monthLabels = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
}

function AppealsPie({ appealsInfo }) {
  const convertToChartData1 = (info) => {
    let chartData = []

    if (info) {
      let totalPaidCount = parseInt(info["Resolved Commission Count"] || 0) + parseInt(info["Resolved Rebates Count"])
      let remainingCount = parseInt(info["Total Escalations"]) - totalPaidCount
      chartData = [
        {
          id: 1,
          value: totalPaidCount,
          label: "Paid Escalations",
          color: "var(--va-primary-color)",
          percentage: (totalPaidCount / (totalPaidCount + remainingCount)) * 100,
        },
        {
          id: 2,
          value: remainingCount,
          percentage: (remainingCount / (totalPaidCount + remainingCount)) * 100,

          label: "Pending Escalations",
          //   color: "#00162b",
          // color: "rgb(11, 61, 143)",
          color: "rgb(170, 170, 170)",
        },
      ]
    }
    return chartData
  }

  const convertToChartData2 = (info) => {
    let chartData = []
    if (info) {
      let escalated_commission_count = parseInt(info["Escalated Commission Count"] || 0)
      let escalated_rebate_count = parseInt(info["Escalated Rebates Count"] || 0)
      let resolved_commission_count = parseInt(info["Resolved Commission Count"] || 0)
      let resolved_rebate_count = parseInt(info["Resolved Rebates Count"] || 0)

      let pending_rebate_count = escalated_rebate_count - resolved_rebate_count

      // console.log("escalated_rebate_count", escalated_rebate_count)
      let pending_commission_count = escalated_commission_count - resolved_commission_count

      // console.log("pending_rebate_count", pending_rebate_count)
      chartData = [
        {
          id: 2,
          value: pending_commission_count,
          label: "Pending Commission",
          color: "rgb(199, 199, 199)",
        },
        {
          id: 0,
          value: pending_rebate_count,
          label: "Pending Rebate",
          //   color: "rgb(7, 179, 198)",
          color: "rgb(170, 170, 170)",
        },
        {
          id: 1,
          value: resolved_rebate_count,
          label: "Paid Rebate",
          color: "rgb(7, 179, 198)",
        },

        {
          id: 3,
          value: resolved_commission_count,
          label: "Paid Commission",
          color: "rgb(7, 198, 195)",
        },
      ]
    }
    return chartData
  }

  return (
    <div>
      <Card
        // key={`${year}-${month}`}
        sx={{
          zoom: 0.9,
          width: "100%",
          maxWidth: "calc(100vw - 75px)",
          overflow: "auto",
          display: "inline-block",
          minHeight: 250,
          padding: "0px",
        }}
        className="visual-info-main-card"
      >
        <CardContent>
          <Typography variant="h5" gutterBottom className="va-heading-1">
            Escalation Breakdown
            {/* - {month}, {year} */}
          </Typography>

          {/* Optionally render a pie chart */}
          <VAPieChart2 chartData={convertToChartData1(appealsInfo)} chartData1={convertToChartData1(appealsInfo)} chartData2={convertToChartData2(appealsInfo)}>
            <div
              style={{
                display: "flex",
                gap: 20,
                fontFamily: "Roboto Mono",
                fontWeight: "bold",
              }}
            >
              <div style={{ fontWeight: "bold" }}>Total Escalations:</div> <div> {appealsInfo?.["Total Escalations"]} </div>
            </div>
          </VAPieChart2>

          {/* {Object.entries(info).map(([label, value]) => (
                      <Typography key={label} variant="body1">
                        {label}: {value.toLocaleString()}
                      </Typography>
                    ))} */}
        </CardContent>
      </Card>
    </div>
  )
}
export default AppealsPie
